<app-skip-link />
@if (isLogged() | async) {
  <app-status-bar />
}
<div class="app-container">
  <app-header />
  <main class="nhsuk-main-wrapper py-0" id="maincontent">
    @if (!isIframe) {
      <router-outlet />
    }
  </main>
  <div class="disclaimer-container">
    <app-disclaimer />
  </div>
  <div class="footer-container">
    <app-footer />
  </div>
</div>
